import { getCurrentCulture } from "@utils";

export const urlLanguageDetector = {
	name: "urlLanguageDetector",

	lookup() {
		return getCurrentCulture();
	},
};
